'use strict';

module.exports = 0;



//////////////////
// WEBPACK FOOTER
// ./~/shortid/lib/util/cluster-worker-id-browser.js
// module id = 487
// module chunks = 4 6 7 8 9 10 12 21 22 23 24 27 56 57